<template>
  <div style="width: 100%">
    <v-alert border="left" v-bind="$attrs" :color="color" class="scroll-group-header" elevation="4" rounded dense>
      <template #prepend v-if="icon">
        <v-icon class="mr-4">{{icon}}</v-icon>
      </template>

      {{title}} <v-btn test-tag="tag-150" v-if="counter !== undefined && !expanded" icon depressed small style="transform: translateY(-.7em); font-size: .7em">{{counter >= 100 ? `99+` : counter}}</v-btn>

      <template #append>
        <v-btn test-tag="tag-151" icon @click="expanded = !expanded" :style="expanded ? 'transform: rotate(-90deg)' : ''" style="transition: all .2s ease-in-out">
          <v-icon>mdi-chevron-left</v-icon>
        </v-btn>
      </template>
    </v-alert>
    <transition name="fade" duration="100">
      <transition-group name="slide" duration="100" mode="out-in" v-if="expanded">
        <slot />
      </transition-group>
    </transition>
  </div>
</template>

<script>
export default {
  props: {
    color: String,
    title: {
      type: String,
      default: 'Title'
    },
    counter: {
      type: Number,
      default: undefined
    },
    icon: [() => undefined, String],
    defaultFolded: Boolean
  },
  data: () => ({
    is_expanded: undefined
  }),
  computed: {
    expanded: {
      get() {
        return this.is_expanded !== undefined ? this.is_expanded : !this.defaultFolded
      },
      set(v) {
        this.is_expanded = v
      }
    }
  }
}
</script>

<style>
.scroll-group-header {
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 3;
}
</style>